import React from "react";
import { SITE_COMMISSION_PERCENT } from "../../config/platformFees";
import { formatMoney } from "./utils";

export default function EarningsSummary({ earnings, isAr }) {
  const { summary } = earnings;

  const primaryMetrics = [
    {
      key: "total",
      icon: "bi-graph-up-arrow",
      iconClass: "pc-metric-card__icon--green",
      label: isAr ? "إجمالي الأرباح" : "Total Earned",
      value: formatMoney(summary.total_earned, summary.currency),
      valueClass: "",
    },
    {
      key: "available",
      icon: "bi-wallet2",
      iconClass: "pc-metric-card__icon--emerald",
      label: isAr ? "المتاح للسحب" : "Available",
      value: formatMoney(summary.available_balance, summary.currency),
      valueClass: "pc-metric-card__value--success",
    },
    {
      key: "hold",
      icon: "bi-hourglass-split",
      iconClass: "pc-metric-card__icon--yellow",
      label: isAr
        ? `قيد المراجعة (${summary.withdrawal_hold_days || 7} أيام)`
        : `On Hold (${summary.withdrawal_hold_days || 7} days)`,
      value: formatMoney(summary.pending_clearance, summary.currency),
      valueClass: "pc-metric-card__value--warning",
    },
    {
      key: "pending",
      icon: "bi-send",
      iconClass: "pc-metric-card__icon--blue",
      label: isAr ? "قيد السحب" : "Pending Withdrawals",
      value: formatMoney(summary.pending_withdrawals, summary.currency),
      valueClass: "",
    },
    {
      key: "paidout",
      icon: "bi-check2-circle",
      iconClass: "pc-metric-card__icon--teal",
      label: isAr ? "تم سحبها" : "Paid Out",
      value: formatMoney(summary.paid_out, summary.currency),
      valueClass: "",
    },
  ];

  const sourceMetrics = [
    {
      key: "services",
      icon: "bi-tools",
      iconClass: "pc-metric-card__icon--amber",
      label: isAr ? "الخدمات" : "Services",
      value: formatMoney(summary.services_earned, summary.currency),
    },
    {
      key: "consultations",
      icon: "bi-chat-dots",
      iconClass: "pc-metric-card__icon--purple",
      label: isAr ? "الاستشارات" : "Consultations",
      value: formatMoney(summary.consultations_earned, summary.currency),
    },
    {
      key: "courses",
      icon: "bi-play-circle",
      iconClass: "pc-metric-card__icon--blue",
      label: isAr ? "الكورسات" : "Courses",
      value: formatMoney(summary.courses_earned, summary.currency),
    },
    {
      key: "products",
      icon: "bi-bag",
      iconClass: "pc-metric-card__icon--amber",
      label: isAr ? "المنتجات" : "Products",
      value: formatMoney(summary.products_earned, summary.currency),
    },
  ];

  return (
    <>
      <div className="alert alert-info border-0 shadow-sm mb-3">
        <strong>{isAr ? "سياسة العمولة:" : "Commission policy:"}</strong>{" "}
        {isAr
          ? `في العمليات الجديدة الخاصة بالكورسات والاستشارات والخدمات، عمولة الموقع ${SITE_COMMISSION_PERCENT}% ورسوم Stripe تُعرض على المشتري بشكل منفصل قبل الدفع. رسوم سحب IBAN تُعرض لك هنا عند طلب السحب، بينما أي رسوم Wise أو بنك مراسل هي رسوم مزود تحويل خارجي وليست عمولة إضافية للموقع.`
          : `For new course, consultation, and service purchases, the ${SITE_COMMISSION_PERCENT}% site fee and Stripe fee are shown to the buyer separately before payment. IBAN withdrawal fees are shown here when you request a payout, while any Wise or correspondent-bank fees belong to the transfer provider, not to the platform.`}
      </div>

      <div className="row g-3 mb-3">
        {primaryMetrics.map((metric) => (
          <div className="col-12 col-sm-6 col-xl-4" key={metric.key}>
            <div className="pc-metric-card">
              <div className={`pc-metric-card__icon ${metric.iconClass}`}>
                <i className={`bi ${metric.icon}`} />
              </div>
              <div>
                <div className="pc-metric-card__label">{metric.label}</div>
                <div className={`pc-metric-card__value ${metric.valueClass || ""}`}>
                  {metric.value}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="pc-section-divider mb-3">
        <span>{isAr ? "مصادر الأرباح" : "Earnings by source"}</span>
      </div>

      <div className="row g-3 mb-4">
        {sourceMetrics.map((metric) => (
          <div className="col-12 col-sm-6 col-xl-3" key={metric.key}>
            <div className="pc-metric-card">
              <div className={`pc-metric-card__icon ${metric.iconClass}`}>
                <i className={`bi ${metric.icon}`} />
              </div>
              <div>
                <div className="pc-metric-card__label">{metric.label}</div>
                <div className="pc-metric-card__value">{metric.value}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
